export enum ImageEngineEnum {
  DALL_E_3 = 1, // default
  RECRAFT_V3 = 2,
}
